import React, { memo } from 'react';
import PropTypes from 'prop-types';

import colors from '../constants/colors';

const MaintenanceFilled = (props) => (
  <svg {...props} viewBox="0 0 68 68">
    <g fill="none" fillRule="evenodd">
      <path
        d="m3.2 61.378 5.133 5.134 18.823-20.535-5.134-5.133L3.2 61.378ZM52.823 8.331l6.845 6.845 6.844-8.556-5.133-5.133-8.556 6.844Z"
        fill={props.fillColor}
      />
      <path
        d="m40.745 33.004 9.918 10 .433-.137a12.652 12.652 0 0 1 12.259 2.884l.352.34c3.69 3.722 4.712 9.278 2.71 14.039a1.426 1.426 0 0 1-2.136.614l-.15-.123-5.67-5.276H54.8v3.69l5.347 5.593a1.426 1.426 0 0 1-.298 2.209l-.175.088a12.661 12.661 0 0 1-13.96-2.733c-3.346-3.37-4.499-8.25-3.196-12.683l.14-.453-9.932-10.01 2.025-2.009 10.577 10.661c.407.41.526 1.024.303 1.557-1.559 3.71-.764 8.036 2.108 10.927a9.801 9.801 0 0 0 8.393 2.801l.353-.06-4.141-4.329a1.426 1.426 0 0 1-.379-.768l-.016-.218V53.92c0-.727.544-1.327 1.247-1.415l.179-.011h5.645c.289 0 .568.087.804.248l.168.134 4.407 4.101.068-.4a9.997 9.997 0 0 0-2.487-8.161l-.3-.316a9.803 9.803 0 0 0-10.818-2.122 1.426 1.426 0 0 1-1.427-.18l-.144-.127L38.72 35.013l2.025-2.009ZM61.46.318a1.426 1.426 0 0 1 1.83.164l4.235 4.267c.496.5.553 1.288.133 1.854l-7.244 9.765a1.426 1.426 0 0 1-2.157.155l-2.33-2.345-28.134 28.348 4.986 5.027a1.426 1.426 0 0 1-1.88 2.137l-.145-.128-1.98-1.996L11.24 65.238a5.63 5.63 0 0 1-7.83.178l-.182-.176a5.71 5.71 0 0 1 0-8.04L20.78 39.507l-1.995-2.011a1.426 1.426 0 0 1 1.88-2.137l.145.128 4.974 5.015 28.133-28.348-2.647-2.665a1.426 1.426 0 0 1 .08-2.084l.114-.09ZM22.785 41.534 5.252 59.209a2.86 2.86 0 0 0 .002 4.024 2.779 2.779 0 0 0 3.96-.003l17.55-17.687-3.979-4.01Zm-1.017-37.7c3.347 3.37 4.5 8.252 3.198 12.685l-.142.45L34.75 26.97l-2.024 2.01-10.572-10.65a1.426 1.426 0 0 1-.302-1.557c1.558-3.71.763-8.04-2.108-10.93-2.256-2.27-5.248-3.24-8.197-2.803l-.45.08 3.827 4.35c.184.208.301.463.34.735l.016.206V14.1c0 .727-.544 1.327-1.247 1.415l-.18.01H8.21c-.29 0-.57-.087-.806-.248l-.168-.135-4.154-3.883-.064.382a9.825 9.825 0 0 0 2.486 8.074l.3.316c2.848 2.872 7.124 3.642 10.817 2.065a1.426 1.426 0 0 1 1.427.178l.144.127 10.575 10.633-2.022 2.01-9.922-9.976-.437.142c-4.265 1.283-8.935.27-12.257-2.831l-.35-.34a12.696 12.696 0 0 1-2.71-13.936 1.426 1.426 0 0 1 2.137-.612l.15.123 5.414 5.059h3.659V8.947l-4.92-5.593a1.426 1.426 0 0 1 .342-2.168l.17-.086C12.745-.913 18.066.106 21.768 3.834Zm40.342-.49-7.623 5.335 4.625 4.656 5.524-7.449-2.526-2.543Z"
        fill={props.color}
      />
    </g>
  </svg>
);

MaintenanceFilled.defaultProps = {
  width: 68,
  height: 68,
  color: colors.text,
  fillColor: colors.babyBlue,
};

MaintenanceFilled.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  fillColor: PropTypes.string,
};

export default memo(MaintenanceFilled);
